export default __webpack_public_path__ + "static/media/face-6.da6bf6f5.jpg";